import { ComponentProps } from 'react';

import { cn } from '@/app/shared/lib/cn';

export interface InputProps extends ComponentProps<'input'> {
  limitLength?: boolean;
  maxLength?: number;
}

export const Input = ({ className, limitLength = true, maxLength = 30, ...props }: InputProps) => {
  return (
    <input
      className={cn('rounded border px-4 py-2 font-normal focus:outline-none', className)}
      maxLength={limitLength ? maxLength : undefined}
      {...props}
    />
  );
};

Input.displayName = 'Input';
